import { render, staticRenderFns } from "./SocialFeed.vue?vue&type=template&id=0e3b2766&scoped=true"
import script from "./SocialFeed.vue?vue&type=script&lang=js"
export * from "./SocialFeed.vue?vue&type=script&lang=js"
import style0 from "./SocialFeed.vue?vue&type=style&index=0&id=0e3b2766&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e3b2766",
  null
  
)

export default component.exports